<template>
  <div class="dialog">
    <transition appear name="fade" :duration="1000000">
      <div class="layer" @click="close()"></div>
    </transition>
    <div class="content" ref="content">
      <TrackEmbed :track="track" :login="login" :modal="true" />
      <Share :track="track" class="share" />
      <button type="button" class="close" @click="close()"></button>
    </div>
  </div>
</template>

<script>
import TrackEmbed from '@/components/TrackEmbed'
import Share from '@/components/Share'
export default {
  name: 'HomeTracksModal',
  props: ['login', 'track', 'close'],
  data () {
    return {
      width: 0
    }
  },
  components: {
    TrackEmbed,
    Share
  },
  methods: {
    checkWidth () {
      if (window.innerWidth < 1200) {
        this.$router.push({
          name: 'Track',
          params: {
            slug: this.track.slug
          }
        })
      }
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.checkWidth)
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.checkWidth);
    })
    this.checkWidth()
  }
}
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
@import '../../../scss/easing';
.dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .layer {
    background: $black;
    opacity: 0.8;
    width: 100%;
    height: 100%;
    z-index: 1;
    position: fixed;

    animation: fade-in-layer 0.5s linear forwards;
    @keyframes fade-in-layer {
      from {
        opacity : 0;
      }
      to {
        opacity: 0.8;
      }
    }
  }

  .content {
    padding: 20px;
    background: #fff;
    position: absolute;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 80vw;
    margin-top: 80px;
    margin-bottom: 80px;
    // max-height: 100vh;
    opacity: 0;
    animation: fade-in-content 1s $easeInOutQuint forwards 0.4s;
    @keyframes fade-in-content {
      from {
        opacity : 0;
        transform: translateX(-50%) translateY(10%);
      }
      to {
        opacity: 1;
        transform: translateX(-50%) translateY(0%);
      }
    }    
  }

  .share {
    position: fixed;
    top: 0;
    right: -63px;
    z-index: 1;
  }

  .close {
    cursor: pointer;
    border-color: transparent;
    outline: none;
    filter: invert(100%);
    background-color: transparent;
    background-size: cover;
    background-image: url('/static/images/close.svg');
    background-repeat: no-repeat;
    background-position: 50% 50%;
    width: 25px;
    height: 25px;
    position: fixed;
    top: -5%;
    right: -70px;
    margin-right: 28px;
    transition: transform 0.3s $easeOutBack;
    &:hover {
      transform: scale(1.1);
    }
    &:active {
      transform: scale(0.9);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Tracks/Modal.vue